import { createContext } from "react";
export var ControlledSize;
(function (ControlledSize) {
    ControlledSize[ControlledSize["First"] = 0] = "First";
    ControlledSize[ControlledSize["Second"] = 1] = "Second";
})(ControlledSize || (ControlledSize = {}));
export var SplitDirection;
(function (SplitDirection) {
    SplitDirection[SplitDirection["Horizontal"] = 0] = "Horizontal";
    SplitDirection[SplitDirection["Vertical"] = 1] = "Vertical";
})(SplitDirection || (SplitDirection = {}));
// Create the context
export const SplitContext = createContext({ direction: SplitDirection.Horizontal, drag: () => { }, beginDrag: () => { }, endDrag: () => { }, sync: () => { } });
//# sourceMappingURL=splitContext.js.map